import { render, staticRenderFns } from "./BoxLineObjectDrawer.vue?vue&type=template&id=f80aea62&scoped=true&"
import script from "./BoxLineObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./BoxLineObjectDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./BoxLineObjectDrawer.vue?vue&type=style&index=0&id=f80aea62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80aea62",
  null
  
)

export default component.exports